// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"Dl","summaryPar":"El","ratingCategories":"Fl","reviewerInfo":"Gl","reviewTypes":"Hl","expanded":"Il"};